import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { MoneyApi } from "go-core/api/types";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { selectPartner } from "../../../../../../../../../services/partner/selectors";

interface Props {
	balance: MoneyApi;
}

const PartnerBalanceCard = ({ balance }: Props) => {
	const { t } = useTranslation("admin");
	const history = useHistory();
	const partner = useSelector(selectPartner);

	return (
		<Card>
			<Card.Body>
				<h5>{t("modules.partner.field.balance.title")}</h5>
				<div className="d-flex flex-column">
					<div className="card-body-item">
						{t("modules.partner.field.to_pay.title")}
						<span className="ms-1">{FormatMoney(balance)}</span>
					</div>
					<Button
						variant="add"
						onClick={() => history.push(`/partnership/${partner?.id}/payout_invoices/new`)}
					>
						{t("common.action.pay_out")}
					</Button>
				</div>
			</Card.Body>
		</Card>
	);
};

export default PartnerBalanceCard;
